import React, { Component } from "react";
import Select from 'react-select';
// Usar react-date-range compatible con React 17
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import 'moment/locale/es';
import '../styles/datepicker-override.css';
import '../styles/pagination-override.css';
import ReactPaginate from 'react-paginate';

import { LangContext } from "../LangContext.jsx";
moment.locale('es');
class ReportsDossiers extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            dossiers: [],
            currentPage: 0,
            itemsPerPage: 10,
            totalPages: 0,
            showFrom: 0,
            showTo: 0,
            totalDossiers: 0,
            showExport: true,
            showRut: false,
            selectedTipoExpediente: null,
            selectedFiscalName: null,
            selectedRfc: null,
            selectedEmail: null,
            selectedStatus: null,
            selectedInternalId: null,
            selectedRelation: null,
            selectedDossierTypeTitle: null,
            selectedDossierTitle: null,
            selectedTotalDocuments: null,
            selectedUniques: null,
            selectedRecurrents: null,
            tipoExpedienteOptions: [
                {value: 1, label: "Normal"},
                {value: 2, label: "Interno"},
                {value: 3, label: "Propio"},
            ],
            fiscalNameOptions: [],
            internalIdOptions:[],
            rfcOptions: [],
            emailOptions: [],
            statusOptions: [
                {value: "Actualizado", label: "Actualizado"},
                {value: "Historial", label: "Historial"},
                {value: "Completo", label: "Completo"},
                {value: "Declinado", label: "Declinado"},
                {value: "Incompleto", label: "Incompleto"},
                {value: "Invitado", label: "Invitado"},
                {value: "Rechazado", label: "Rechazado"},
                {value: "Vigente", label: "Vigente"},
            ],
            relationOptions: [
                {value: 1, label: "Cliente"},
                {value: 2, label: "Proveedor"},
                {value: 3, label: "Empleado"},
            ],
            dossierTypeTitleOptions: [
                {value: "Nacional", label: "Nacional"},
                {value: "Internacional", label: "Internacional"},
                {value: "Especiales", label: "Especiales"},
                {value: "Otros", label: "Otros"},
            ],
            dossierTitleOptions: [],
            totalDocumentsOptions: [],
            uniquesOptions: [],
            recurrentsOptions: [],
            statusStartDate: null,
            statusEndDate: null,
            statusDateFocusedInput: null,
            aceptedStartDate: null,
            aceptedEndDate: null,
            aceptedDateFocusedInput: null,
            expiredStartDate: null,
            expiredEndDate: null,
            expiredDateFocusedInput: null,
            // popovers
            showStatusPicker: false,
            showExpiredPicker: false,
            showAcceptedPicker: false,
            showAdvancedFilters: false,
            params : {
                dossier:{
                    tipo_expediente: null,
                    fiscal_name: null,
                    internal_id:null,
                    rfc: null,
                    email: null,
                    status: null,
                    status_date: null,
                    relation: null,
                    dossier_type_title: null,
                    dossier_title: null,
                    total_documents: null,
                    uniques: null,
                    recurrents: null,
                    expired_date: null,
                    acepted_date: null
                },
                sort:{
                    order: null,
                    column: null
                },
                page: 0,
                limit:  10,
            },
        };
        // refs para click afuera
        this.statusPickerRef = React.createRef();
        this.expiredPickerRef = React.createRef();
        this.acceptedPickerRef = React.createRef();
    }

    getDossiers(){
        const { currentPage, itemsPerPage } = this.state;
        axios.get('/api/reports/dossiers', {
                params: {
                    ...this.state.params,
                    page: currentPage +1,
                    limit: itemsPerPage
                }
            }).then(res=>{
                let dossiers = res.data.data;

                this.setState({
                    dossiers,
                    showFrom: res.data.from,
                    showTo: res.data.to,
                    totalDossiers: res.data.total,
                    totalPages: Math.ceil(res.data.total / itemsPerPage)
                });
        })
        this.getFilters();
    }

    getFilters() {
        axios.get('/api/filters/dossiers', {
            params: {
                ...this.state.params,
            }
        }).then((res) => {
            const dossierFilters = res.data;
            this.setState({
                idOptions: dossierFilters.idOptions,
                fiscalNameOptions: dossierFilters.fiscalNameOptions,
                internalIdOptions: dossierFilters.internalIdOptions,
                rfcOptions: dossierFilters.rfcOptions,
                emailOptions: dossierFilters.emailOptions,
                dossierTitleOptions: dossierFilters.dossierTitleOptions,
                totalDocumentsOptions: dossierFilters.totalDocumentsOptions,
                uniquesOptions: dossierFilters.uniquesOptions,
                recurrentsOptions: dossierFilters.recurrentsOptions,
            });
        });
    }

    exportReports() {
        const ids = this.state.idOptions.map(item => item.value);
        const dataJSON = JSON.stringify(ids);

        axios.post('/api/export/dossiers', {
            data: dataJSON,
        }, {
            responseType: 'blob',
        }).then(response => {
            console.log(response)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            const fileName = 'ReporteExpedientes.xls';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    }


    componentDidMount() {
        this.getDossiers();
        document.addEventListener('mousedown', this.handleClickOutside);
    };

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleNameChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            user: {
                ...this.state.params.user,
                name: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedName: event,
        }, this.getDossiers);
    }

    handleTipoExpedienteChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                tipo_expediente: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedTipoExpediente: event,
        }, this.getDossiers);
    }

    handleFiscalNameChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                fiscal_name: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedFiscalName: event,
        }, this.getDossiers);
    }

    handleRfcChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                rfc: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRfc: event,
        }, this.getDossiers);
    }

    handleEmailChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                email: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedEmail: event,
        }, this.getDossiers);
    }

    handleStatusChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                status: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedStatus: event,
        }, this.getDossiers);
    }


    handleInternalIdChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                internal_id: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedInternalId: event,
        }, this.getDossiers);
    }


    handleRelationChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                relation: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRelation: event,
        }, this.getDossiers);
    }

    handleDossierTypeTitleChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                dossier_type_title: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedDossierTypeTitle: event,
        }, this.getDossiers);
    }

    handleDossierTitleChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                dossier_title: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedDossierTitle: event,
        }, this.getDossiers);
    }

    handleTotalDocumentsChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                total_documents: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedTotalDocuments: event,
        }, this.getDossiers);
    }

    handleUniquesChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                uniques: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedUniques: event,
        }, this.getDossiers);
    }

    handleRecurrentsChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                recurrents: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRecurrents: event,
        }, this.getDossiers);
    }

    handleStatusDateChange = (ranges) => {
        const sel = ranges.selection || {};
        const startDate = sel.startDate || null;
        const endDate = sel.endDate || null;
        const startStr = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endStr = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        const { params } = this.state;
        const updatedParams = {
            ...params,
            dossier: {
                ...params.dossier,
                status_date: { startDate: startStr, endDate: endStr },
            },
        };
        this.resetCurrentPage();
        this.setState({
            statusStartDate: startStr,
            statusEndDate: endStr,
            params: updatedParams,
        }, this.getDossiers);
    };

    handleAceptedDateChange = (ranges) => {
        const sel = ranges.selection || {};
        const startDate = sel.startDate || null;
        const endDate = sel.endDate || null;
        const startStr = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endStr = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        const { params } = this.state;
        const updatedParams = {
            ...params,
            dossier: {
                ...params.dossier,
                acepted_date: { startDate: startStr, endDate: endStr },
            },
        };
        this.resetCurrentPage();
        this.setState({
            aceptedStartDate: startStr,
            aceptedEndDate: endStr,
            params: updatedParams,
        }, this.getDossiers);
    };

    handleExpiredDateChange = (ranges) => {
        const sel = ranges.selection || {};
        const startDate = sel.startDate || null;
        const endDate = sel.endDate || null;
        const startStr = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endStr = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        const { params } = this.state;
        const updatedParams = {
            ...params,
            dossier: {
                ...params.dossier,
                expired_date: { startDate: startStr, endDate: endStr },
            },
        };
        this.resetCurrentPage();
        this.setState({
            expiredStartDate: startStr,
            expiredEndDate: endStr,
            params: updatedParams,
        }, this.getDossiers);
    };

    // popover open/close helpers
    toggleStatusPicker = () => this.setState(prev => ({ showStatusPicker: !prev.showStatusPicker }));
    toggleExpiredPicker = () => this.setState(prev => ({ showExpiredPicker: !prev.showExpiredPicker }));
    toggleAcceptedPicker = () => this.setState(prev => ({ showAcceptedPicker: !prev.showAcceptedPicker }));
    handleClickOutside = (e) => {
        const { showStatusPicker, showExpiredPicker, showAcceptedPicker } = this.state;
        if (showStatusPicker && this.statusPickerRef.current && !this.statusPickerRef.current.contains(e.target)) {
            this.setState({ showStatusPicker: false });
        }
        if (showExpiredPicker && this.expiredPickerRef.current && !this.expiredPickerRef.current.contains(e.target)) {
            this.setState({ showExpiredPicker: false });
        }
        if (showAcceptedPicker && this.acceptedPickerRef.current && !this.acceptedPickerRef.current.contains(e.target)) {
            this.setState({ showAcceptedPicker: false });
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        this.setState({ currentPage: selected }, this.getDossiers);
    }

    handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value, 10);
        this.setState({
            itemsPerPage: newItemsPerPage,
            currentPage: 0
        }, this.getDossiers);
    };

    resetCurrentPage = () => {
        this.setState({
            currentPage: 0,
        });
    }

    clearStatusDates = () => {
        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                status_date: null
            }
        };

        this.setState({
            params: updatedParams,
            statusStartDate: null,
            statusEndDate: null
        }, this.getDossiers);
    }

    clearAceptedDates = () => {
        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                acepted_date: null
            }
        };

        this.setState({
            params: updatedParams,
            aceptedStartDate: null,
            aceptedEndDate: null
        }, this.getDossiers);
    }

    clearExpiredDates = () => {
        const updatedParams = {
            ...this.state.params,
            dossier: {
                ...this.state.params.dossier,
                expired_date: null
            }
        };

        this.setState({
            params: updatedParams,
            expiredStartDate: null,
            expiredEndDate: null
        }, this.getDossiers);
    }

    clearFilters = () => {
        this.setState({
            statusStartDate: null,
            statusEndDate: null,
            statusDateFocusedInput: null,
            aceptedStartDate: null,
            aceptedEndDate: null,
            aceptedDateFocusedInput: null,
            expiredStartDate: null,
            expiredEndDate: null,
            expiredDateFocusedInput: null,
            params : {
                dossier:{
                    tipo_expediente: null,
                    fiscal_name: null,
                    rfc: null,
                    email: null,
                    status: null,
                    status_date: null,
                    relation: null,
                    dossier_type_title: null,
                    dossier_title: null,
                    total_documents: null,
                    uniques: null,
                    recurrents: null,
                    expired_date: null,
                    acepted_date: null
                },
                sort:{
                    order: null,
                    column: null
                },
            },
        }, this.getDossiers);
    };
    exportToExcel = () =>{
        const ids = this.state.idOptions.map(item => item.value);
        const dataJSON = JSON.stringify(ids);
        axios.post('/api/export/dossiers_template/extended', {
            ids: dataJSON,
        }).then(res => { 
                let title;
                let html;  
                title = 'Descarga de reporte de expedientes en proceso';
                html = 'Tu solicitud de descarga de reporte de expedientes está en proceso.<br> En breve te compartiremos la liga al correo electrónico registrado.'
                if(res.data.in_process == true){
                    Swal.fire({
                        title: 'Reporte de expedientes',
                        html: 'Tienes un reporte en proceso, intentalo de nuevo mas tarde',
                        icon: 'info',
                        confirmButtonText: 'Aceptar',
                        buttonsStyling: false, 
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        }
                        });
                }else
                {
                    Swal.fire({
                        title: title,
                        html: html,
                        icon: 'info',
                        confirmButtonText: 'Aceptar',
                        buttonsStyling: false, 
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        }
                        });
                }       
        });
    }
    handleSort = (column) => {
        this.setState(prevState => {
            if (column === prevState.params.sort.column) {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: prevState.params.sort.order === 'asc' ? 'desc' : 'asc'
                        }
                    }
                };
            } else {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: 'asc'
                        }
                    }
                };
            }
        }, this.getDossiers);
    };

    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            showAdvancedFilters: !prevState.showAdvancedFilters
        }));
    };

    render() {
        const { lang } = this.context;
        const canSeeExternalDossiersReport = this.props.permissions?.reports_list?.includes('all') || this.props.permissions?.reports_list?.includes('dossiers');
        const canSeeInternalDossiersReport = this.props.permissions?.reports_list_internal?.includes('all') || this.props.permissions?.reports_list_internal?.includes('dossiers');
        const canSeeOwnDossiersReport = this.props.permissions?.reports_list_own?.includes('all') || this.props.permissions?.reports_list_own?.includes('dossiers');

        const tipoExpedienteOptions = [];
        if (canSeeExternalDossiersReport) {
            tipoExpedienteOptions.push({ value: 1, label: 'Normal' });
        }

        if (canSeeInternalDossiersReport) {
            tipoExpedienteOptions.push({ value: 2, label: 'Interno' });
        }

        if (canSeeOwnDossiersReport) {
            tipoExpedienteOptions.push({ value: 3, label: 'Propio' });
        }

        return (
        <>
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div>
                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                            {lang.get('messages.reporte_de_expedientes')}
                        </h5>
                        <p className="text-dark-50 font-weight-bold my-1 mr-5">
                            <span className="text-primary datatable-count">{this.state.totalDossiers}</span> {lang.get('messages.expedientes_solicitados')}
                        </p>
                    </div> 
                    <div className="d-flex align-items-center flex-wrap"> 
                    
                        {   this.state.showExport &&
                            <div>
                                <div className="dropdown dropdown-inline">
                                <a href="#" className="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {lang.get('messages.acciones')}
                                        &nbsp;&nbsp;
                                        <i className="flaticon2-down icon-sm"></i>
                                    </a> 
                                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg"  > 
                                        <ul className="navi navi-hover">
                                        <li class="navi-item">
                                                <a  className="navi-link py-4" onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.exportReports("compact");
                                                }}>
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon-download text-primary icon-md"></span>
                                                    </span>
                                                    <span className="navi-text text-secondary">Exportar Reporte Compacto</span>
                                                    <span className="navi-icon pull-right">
                                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                        </button>
                                                    </span>
                                                </a>
                                            </li> 
                                            <li class="navi-item">
                                                <a  className="navi-link py-4" onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.exportToExcel();
                                                    }}>
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon-download text-primary icon-md"></span>
                                                    </span>
                                                    <span className="navi-text text-secondary">Exportar Reporte Completo<br></br> 
                                                    </span> 
                                                    <span className="navi-icon pull-right">
                                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                        </button>
                                                    </span>
                                                </a>
                                            </li>  
                                        </ul>
                                    </div> 
                                </div> 
                            </div>
                        }
                        </div>
                </div>
            </div>
            
            <div className="container">
                <div className="datatable-filters">
                    <div className="d-flex justify-content-between mb-4">
                        <div className="font-weight-bolder">{lang.get('messages.filtrar_por')}</div>
                        <a
                            className="datatable-clear-filters float-right text-primary"
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.clearFilters();
                            }}
                        ><strong>{lang.get('messages.limpiar_todos_los_filtros')}</strong></a>
                    </div>
                        <div className="d-flex justify-content-between mb-4 default">
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.tipo_de_expediente')}</label>
                                <Select
                                    value={this.state.selectedTipoExpediente}
                                    onChange={this.handleTipoExpedienteChange}
                                    options={tipoExpedienteOptions}
                                    placeholder={<div>{lang.get('messages.buscar_por_tipo_de_expediente')}</div>}
                                    isClearable={true}
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.razon_social')}</label>
                                <Select
                                    value={this.state.selectedFiscalName}
                                    onChange={this.handleFiscalNameChange}
                                    options={this.state.fiscalNameOptions}
                                    placeholder={<div>{lang.get('messages.buscar_por_razon_social')}</div>}
                                    isClearable={true}
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.rfc')}</label>
                                <Select
                                    value={this.state.selectedRfc}
                                    onChange={this.handleRfcChange}
                                    options={this.state.rfcOptions}
                                    placeholder={<div>{lang.get('messages.buscar_por_rfc')}</div>}
                                    isClearable={true}
                                />
                            </div>
                        </div>
                        {this.state.showAdvancedFilters && (
                        <div className="advanced-filters">
                            <div className="d-flex justify-content-between mb-4 default">
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">Identificador interno</label>
                                    <Select
                                        value={this.state.selectedInternalId}
                                        onChange={this.handleInternalIdChange}
                                        options={this.state.internalIdOptions}
                                        placeholder={<div>Buscar por identificador interno</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.correo')}</label>
                                    <Select
                                        value={this.state.selectedEmail}
                                        onChange={this.handleEmailChange}
                                        options={this.state.emailOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_correo')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                
                                <div className="col-md-4">
                                    <div className="datepicker-container">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.fecha')}</label><br></br>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                className="form-control d-flex align-items-center justify-content-between"
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.toggleStatusPicker}
                                            >
                                                <span>{this.state.statusStartDate ? moment(this.state.statusStartDate).format('ll') : lang.get('messages.fecha_inicio')}</span>
                                                <span className="mx-2">–</span>
                                                <span>{this.state.statusEndDate ? moment(this.state.statusEndDate).format('ll') : lang.get('messages.fecha_fin')}</span>
                                                {(this.state.statusStartDate || this.state.statusEndDate) && (
                                                    <span onClick={(e) => { e.stopPropagation(); this.clearStatusDates(); }} style={{ marginLeft: 'auto' }}>
                                                        <i className="flaticon2-delete text-muted"></i>
                                                    </span>
                                                )}
                                            </div>

                                            {this.state.showStatusPicker && (
                                                <div ref={this.statusPickerRef} className="date-range-popover">
                                                    <DateRange
                                                        ranges={[{
                                                            startDate: this.state.statusStartDate ? new Date(this.state.statusStartDate) : new Date(),
                                                            endDate: this.state.statusEndDate ? new Date(this.state.statusEndDate) : new Date(),
                                                            key: 'selection'
                                                        }]}
                                                        onChange={this.handleStatusDateChange}
                                                        editableDateInputs={true}
                                                        moveRangeOnFirstSelection={false}
                                                        months={1}
                                                        direction="horizontal"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">
                            <div className="col-md-4">
                                <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.estatus')}</label>
                                    <Select
                                        value={this.state.selectedStatus}
                                        onChange={this.handleStatusChange}
                                        options={this.state.statusOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_estatus')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.relacion')}</label>
                                    <Select
                                        value={this.state.selectedRelation}
                                        onChange={this.handleRelationChange}
                                        options={this.state.relationOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_relacion')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.tipo')}</label>
                                    <Select
                                        value={this.state.selectedDossierTypeTitle}
                                        onChange={this.handleDossierTypeTitleChange}
                                        options={this.state.dossierTypeTitleOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_tipo')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                               
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">
                            <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.plantilla_de_expediente')}</label>
                                    <Select
                                        value={this.state.selectedDossierTitle}
                                        onChange={this.handleDossierTitleChange}
                                        options={this.state.dossierTitleOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_plantilla_de_expediente')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">No. Docs</label>
                                    <Select
                                        value={this.state.selectedTotalDocuments}
                                        onChange={this.handleTotalDocumentsChange}
                                        options={this.state.totalDocumentsOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por')} No. Docs</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.unicos')}</label>
                                    <Select
                                        value={this.state.selectedUniques}
                                        onChange={this.handleUniquesChange}
                                        options={this.state.uniquesOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_unicos')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">
                            <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.recurrentes')}</label>
                                    <Select
                                        value={this.state.selectedRecurrents}
                                        onChange={this.handleRecurrentsChange}
                                        options={this.state.recurrentsOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_recurrentes')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="datepicker-container">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.fecha_ultima_vigencia')}</label><br></br>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                className="form-control d-flex align-items-center justify-content-between"
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.toggleExpiredPicker}
                                            >
                                                <span>{this.state.expiredStartDate ? moment(this.state.expiredStartDate).format('ll') : lang.get('messages.fecha_inicio')}</span>
                                                <span className="mx-2">–</span>
                                                <span>{this.state.expiredEndDate ? moment(this.state.expiredEndDate).format('ll') : lang.get('messages.fecha_fin')}</span>
                                                {(this.state.expiredStartDate || this.state.expiredEndDate) && (
                                                    <span onClick={(e) => { e.stopPropagation(); this.clearExpiredDates(); }} style={{ marginLeft: 'auto' }}>
                                                        <i className="flaticon2-delete text-muted"></i>
                                                    </span>
                                                )}
                                            </div>

                                            {this.state.showExpiredPicker && (
                                                <div ref={this.expiredPickerRef} className="date-range-popover">
                                                    <DateRange
                                                        ranges={[{
                                                            startDate: this.state.expiredStartDate ? new Date(this.state.expiredStartDate) : new Date(),
                                                            endDate: this.state.expiredEndDate ? new Date(this.state.expiredEndDate) : new Date(),
                                                            key: 'selection'
                                                        }]}
                                                        onChange={this.handleExpiredDateChange}
                                                        editableDateInputs={true}
                                                        moveRangeOnFirstSelection={false}
                                                        months={1}
                                                        direction="horizontal"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="datepicker-container">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.fecha_de_creacion')}</label><br></br>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                className="form-control d-flex align-items-center justify-content-between"
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.toggleAcceptedPicker}
                                            >
                                                <span>{this.state.aceptedStartDate ? moment(this.state.aceptedStartDate).format('ll') : lang.get('messages.fecha_inicio')}</span>
                                                <span className="mx-2">–</span>
                                                <span>{this.state.aceptedEndDate ? moment(this.state.aceptedEndDate).format('ll') : lang.get('messages.fecha_fin')}</span>
                                                {(this.state.aceptedStartDate || this.state.aceptedEndDate) && (
                                                    <span onClick={(e) => { e.stopPropagation(); this.clearAceptedDates(); }} style={{ marginLeft: 'auto' }}>
                                                        <i className="flaticon2-delete text-muted"></i>
                                                    </span>
                                                )}
                                            </div>

                                            {this.state.showAcceptedPicker && (
                                                <div ref={this.acceptedPickerRef} className="date-range-popover">
                                                    <DateRange
                                                        ranges={[{
                                                            startDate: this.state.aceptedStartDate ? new Date(this.state.aceptedStartDate) : new Date(),
                                                            endDate: this.state.aceptedEndDate ? new Date(this.state.aceptedEndDate) : new Date(),
                                                            key: 'selection'
                                                        }]}
                                                        onChange={this.handleAceptedDateChange}
                                                        editableDateInputs={true}
                                                        moveRangeOnFirstSelection={false}
                                                        months={1}
                                                        direction="horizontal"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {this.state.showAdvancedFilters == false &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-down mr-2"></span> {lang.get('messages.mostrar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                    {this.state.showAdvancedFilters == true &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-up mr-2"></span> {lang.get('messages.ocultar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                </div>
                <div className="table-responsive">
                    <table className="table table-report w-100" id="datatable">
                        <thead>
                            <tr>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('tipo_expediente')}>
                                    {lang.get('messages.tipo_de_expediente')}
                                    {this.state.params.sort.column === 'tipo_expediente' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '250px' }} onClick={() => this.handleSort('fiscal_name')}>
                                    {lang.get('messages.razon_social')}
                                    {this.state.params.sort.column === 'fiscal_name' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '250px' }} onClick={() => this.handleSort('identificador_interno')}>
                                    Identificador interno
                                    {this.state.params.sort.column === 'identificador_interno' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('rfc')}>
                                    RFC
                                    {this.state.params.sort.column === 'rfc' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '250px' }} onClick={() => this.handleSort('email')}>
                                    {lang.get('messages.correo')}
                                    {this.state.params.sort.column === 'email' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('status')}>
                                    {lang.get('messages.estatus')}
                                    {this.state.params.sort.column === 'status' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('status_date')}>
                                    {lang.get('messages.fecha')}
                                    {this.state.params.sort.column === 'status_date' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('relation')}>
                                    {lang.get('messages.relacion')}
                                    {this.state.params.sort.column === 'relation' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('dossier_type_title')}>
                                    {lang.get('messages.tipo')}
                                    {this.state.params.sort.column === 'dossier_type_title' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '200px' }} onClick={() => this.handleSort('dossier_title')}>
                                    {lang.get('messages.plantilla_de_expediente')}
                                    {this.state.params.sort.column === 'dossier_title' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('total_documents')}>
                                    No. Docs
                                    {this.state.params.sort.column === 'total_documents' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('uniques')}>
                                    {lang.get('messages.unicos')}
                                    {this.state.params.sort.column === 'uniques' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('recurrents')}>
                                    {lang.get('messages.recurrentes')}
                                    {this.state.params.sort.column === 'recurrents' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('expired_date')}>
                                    {lang.get('messages.fecha_ultima_vigencia')}
                                    {this.state.params.sort.column === 'expired_date' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('acepted_date')}>
                                    {lang.get('messages.fecha_creacion')}
                                    {this.state.params.sort.column === 'acepted_date' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.dossiers.map((dossier) => (
                                <tr key={dossier.id} id={dossier.id}>
                                    <td className="text-dark-75 font-weight-bolder">
                                        {dossier.tipo_expediente === 1 && lang.get('messages.normal')}
                                        {dossier.tipo_expediente === 2 && lang.get('messages.interno') }
                                        {dossier.tipo_expediente === 3 && lang.get('messages.propio')} 
                                    </td>
                                    <td className="text-dark-50 font-weight-bold">{dossier.fiscal_name}</td>
                                    <td className="text-dark-50 font-weight-bold">{dossier.internal_id}</td>
                                    <td className="text-dark-75 font-weight-bolder">{dossier.rfc}</td>
                                    <td className="text-dark-50 font-weight-bold">{dossier.email}</td>
                                    <td className="text-dark-75 font-weight-bolder">{lang.get('messages.'+dossier.status.toLowerCase())} </td>
                                    <td className="text-dark-50 font-weight-bold">{dossier.status_date}</td>
                                    <td className="text-dark-75 font-weight-bolder">
                                        {dossier.relation === 1 && lang.get('messages.cliente')}
                                        {dossier.relation === 2 && lang.get('messages.proveedor')}
                                        {dossier.relation === 3 && lang.get('messages.empleado')}
                                    </td>
                                    <td className="text-dark-50 font-weight-bold"> {lang.get('messages.'+dossier.dossier_type_title.toLowerCase())} </td>
                                    <td className="text-dark-75 font-weight-bolder">{dossier.dossier_title}</td>
                                    <td className="text-dark-50 font-weight-bold">{dossier.total_documents}</td>
                                    <td className="text-dark-75 font-weight-bolder">{dossier.uniques}</td>
                                    <td className="text-dark-50 font-weight-bold">{dossier.recurrents}</td>
                                    <td className="text-dark-75 font-weight-bolder">{dossier.expired_date}</td>
                                    <td className="text-dark-50 font-weight-bold">{dossier.acepted_date}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between">
                        <div className="col mt-2 px-0">
                            {lang.get('messages.mostrando_del')} {this.state.showFrom} {lang.get('messages.al')} {this.state.showTo} {lang.get('messages.de')} {this.state.totalDossiers} {lang.get('messages.registros')}.
                        </div>
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <p className="mr-2 mt-2">
                                    {lang.get('messages.mostrar')}:
                                </p>
                                <select
                                    value={this.state.itemsPerPage}
                                    onChange={this.handleItemsPerPageChange}
                                    aria-controls="datatable"
                                    className="custom-select custom-select-sm form-control form-control-sm"
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>
                            <ReactPaginate
                                previousLabel={'< ' + lang.get('messages.anterior')}  
                                nextLabel={ lang.get('messages.siguiente') + ' >'} 
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}
                                previousClassName={'previous'}
                                nextClassName={'next'}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
      );
    }
}

export default ReportsDossiers;
